import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-monitor2",
  "use": "icon-monitor2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-monitor2\"><defs><style type=\"text/css\"></style></defs><path d=\"M599.28 550.325l-88.02-226.372-96.119 180.845-53.647-55.186-90.776 56.565 25.607 14.764 58.172-36.255 70.188 72.267 81.272-152.872 89.862 231.24 76.63-161.338 31.234 66.458 34.24-5.74L672.64 395.86z m267.893 175.414V256.672c0-17.551-13.084-31.741-29.245-31.741H187.113c-16.16 0-29.244 14.191-29.244 31.741v469.067H61.957v38.799c0 17.556 13.104 31.74 29.245 31.74h845.83c16.161 0 29.265-14.185 29.265-31.74v-38.799h-99.123z m-293.149 13.32h-119.8v-20.597h119.8v20.597z m232.98-51.886H218.059V290.367h588.945v396.806z m0 0z\" p-id=\"18384\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/monitor2.svg
// module id = gvRU
// module chunks = 197